<template>
  <div class="outer-wrapper">
    <div class="page-wrapper" v-if="resShow">
      <van-loading type="spinner" color="#1989fa"  class="spin"/>
      </div>
      <div class="content-wrapper" v-else>
      <van-tabs swipeable style="width:100%;">
  <van-tab title="任务单内容">
    <transfer-page
        :contract_data="contract_data"
        :total_page="total_page"
        :current_page="current_page"
        id="to_print"
      ></transfer-page>
  </van-tab>
  <van-tab title="执行状态">
    <contract-stat :project_display_no="project_display_no"></contract-stat>
  </van-tab>
</van-tabs>
      </div>
    
  </div>
</template>
<script>
//import contractPage from "./ContractPage.vue";
import transferPage from "./TransferPage.vue";
import contractStat from "./ContractStat.vue";
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "contractInfo",
  components: {
    //contractPage,
    contractStat,
    transferPage
  },
  props: {
    project_display_no: {
      type: String,
      default: "5"
    }
  },
  data() {
    return {
      contract_data: {
        contract_no: NaN,
        project_display_no:'',
        apply_date: "",
        customer: {
          customerCompany: {
            name: "",
            telephone: "",
            fax: "",
            address: ""
          },
          customerPerson: {
            name: "",
            phone: "",
            email: ""
          },
        },
        reportInfo: {
          completeDate: "2019.07.31",
          agentMark: "正常",
          samplePosition: "乙方视检测需求或试样状况确定部位。",
          testMethod: "甲方授权乙方视检测需求确定检测标准。",
          ifSubpackage: "甲方同意乙方视检测需求外发部分或全部检测项目。",
          reportStyle: "乙方视需要编制报告。",
          reportDelivery: "乙方快递（10元费用由甲方另行支付）。",
          restSample: "乙方留存一个月备查，过期由乙方处理。",
          reportLanguage: "中文",
          reportAmount: 1,
          reportMerge: "一个检测类别一份报告"
        },
        sample: [],
        totalPrice: ""
      },
      resShow:true,
      total_page: 1,
      current_page: 1,
    };
  },
  created(){
    this.get_contract_content();
  },
  methods: {
    get_contract_content() {
      this.$axios
        .post(this.$url + "/ask_contract_info", {
          userToken: userToken,
          askData: "contract_data",
          contract_no: this.project_display_no
        })
        .then(response => {
          if(response.data.do_stat=='ok'){
            this.resShow = false;
            this.contract_data = response.data.contract_data;
          }else{
            this.$toast('未查到相关委托单信息！即将返回上个页面！');
            setTimeout(()=>this.$router.go(-1),1000);            
          }
        });
    },
  }
};
</script>
<style scoped>
.outer-wrapper {
  padding: 1rem;
}
.page-wrapper {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
}

.content-wrapper{
  width:100%;

}

.spin{
  margin-top:30%;
}
</style>